export class NotFoundError extends Error {
    constructor(message?: string) {
        super(message)
        this.name = 'NotFoundError'
    }
}

export class NetworkError extends Error {
    constructor(message?: string) {
        super(message)
        this.name = 'NetworkError'
    }
}
